module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset> ';
 if ( transientAlarmCentral ) { 
__p+=' <legend>'+
((__t=( i18n.tc("AlarmGroupOption", "An insurance company and alarm central is already selected") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc("AlarmGroupOption", "Would you like to keep, change or remove the options?") ))==null?'':__t)+
'</p><div class="input"><div><input type="radio" name="alarm-group-option" data-input="alarm-group-option-radio" id="no" value="skip" checked="checked"> <label class="align-left" for="no">'+
((__t=( i18n.tc("AlarmGroupOption", "Keep the options") ))==null?'':__t)+
'</label></div><div><input type="radio" name="alarm-group-option" data-input="alarm-group-option-radio" id="yes" value="change"> <label class="align-left" for="yes">'+
((__t=( i18n.tc("AlarmGroupOption", "Change the options") ))==null?'':__t)+
'</label></div><div><input type="radio" name="alarm-group-option" data-input="alarm-group-option-radio" id="clear" value="clear" checked="checked"> <label class="align-left" for="clear">'+
((__t=( i18n.tc("AlarmGroupOption", "Remove the options") ))==null?'':__t)+
'</label></div></div> ';
 } else { 
__p+=' <legend>'+
((__t=( i18n.tc("AlarmGroupOption", "Set up insurance company and alarm central?") ))==null?'':__t)+
'</legend><div class="input"><div><input type="radio" name="alarm-group-option" data-input="alarm-group-option-radio" id="yes" value="change" checked="checked"> <label class="align-left" for="yes">'+
((__t=( i18n.tc("AlarmGroupOption", "Yes") ))==null?'':__t)+
'</label></div><div><input type="radio" name="alarm-group-option" data-input="alarm-group-option-radio" id="no" value="skip"> <label class="align-left" for="no">'+
((__t=( i18n.tc("AlarmGroupOption", "No") ))==null?'':__t)+
'</label></div></div> ';
 } 
__p+=' </fieldset><fieldset class="button-wrap"><button data-click="group-option-cancel">'+
((__t=( i18n.tc("AlarmGroupOption", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="group-option-submit">'+
((__t=( i18n.tc("AlarmGroupOption", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
